import type { UntitledIconData } from '@faceup/icons'

export const ucPlayButton: UntitledIconData = {
  prefix: 'custom',
  name: 'ucPlayButton',
  viewBox: '0 0 24 24',
  paths: [
    {
      shape:
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2857 14.8868L14.8571 12.8248C15.4921 12.4582 15.4921 11.5418 14.8571 11.1752L11.2857 9.11325C10.6508 8.74668 9.85714 9.20489 9.85714 9.93803V14.062C9.85714 14.7951 10.6508 15.2533 11.2857 14.8868Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
}
